import React from 'react';
import CustomSelect from 'app/components/CustomSelect';

const options = [
  { value: 'Alan hesab1', label: 'Alan hesab1' },
  { value: 'Alan hesab2', label: 'Alan hesab2' },
  { value: 'Alan hesab3', label: 'Alan hesab3' },
  { value: 'Alan hesab4', label: 'Alan hesab4' },
];

const GeneralDetailsCredit = () => {
  return <CustomSelect title={'Kreditin adı'} placeholder={'Kreditin adı'} options={options} />;
};

export default GeneralDetailsCredit;
